/* eslint-disable @typescript-eslint/no-unsafe-call */
import type { ReactNode } from 'react'

import { useState, useEffect } from 'react'

import { PANE_LAYER } from './constants'
import createHTMLMapMarker from './overlay-view'

interface IMapCustomMarker {
  position: google.maps.LatLngLiteral
  map?: google.maps.Map | null | google.maps.StreetViewPanorama
  paneLayer?: PANE_LAYER
  onClick?: () => void
  children: ReactNode
}
export const MapCustomMarker = ({
  position,
  map,
  children,
  paneLayer = PANE_LAYER.floatPane,
  onClick,
}: IMapCustomMarker) => {
  const [marker, setMarker] = useState<google.maps.OverlayView>()

  useEffect(() => {
    if (!marker) {
      setMarker(
        createHTMLMapMarker({
          position,
          content: children,
          paneLayer,
          onClick,
        }) as google.maps.OverlayView,
      )
    }

    return () => {
      if (marker) {
        marker.setMap(null)
      }
    }
  }, [marker]) // eslint-disable-line

  useEffect(() => {
    if (marker && map) {
      marker.setMap(map)
    }
  }, [marker, map])

  return null
}
